import {
  endOfWeek,
  getWeeksInMonth,
  isSameDay,
  isValid,
  isWithinInterval,
  startOfWeek,
} from 'date-fns'

import { typography } from '../../../styles/material-ui/typography'

import { VARIANTS } from './date-picker.constants'

/** @type {Styles} */
export const styles = {
  root: {
    backgroundColor: 'gray.0',
    width: 320,
    '.MuiTypography-root': {
      margin: 0,
    },
    '.PrivatePickersFadeTransitionGroup-root': {
      fontSize: 14,
      overflow: 'hidden',
      fontFamily: typography.fontFamily,
      fontWeight: 600,
      color: 'gray.80',
    },
    '.MuiPickersDay-hiddenDaySpacingFiller': {
      width: 40,
      height: 40,
    },
    '.MuiTypography-caption': {
      width: 40,
      fontSize: 14,
    },
    '.MuiCalendarPicker-root': {
      paddingTop: 0.75,
    },
    '.MuiDateCalendar-root': {
      backgroundColor: 'gray.0',
    },
    '.MuiPickersCalendarHeader-label': {
      color: 'gray.80',
      whiteSpace: 'nowrap',
    },
    '.MuiPickersCalendarHeader-switchViewButton': {
      color: 'gray.56',
      padding: 0,
      '&:hover, &:focus, &:active, &.Mui-focusVisible': {
        backgroundColor: 'transparent',
      },
    },
    '.MuiPickersArrowSwitcher-button': {
      color: 'gray.56',
      padding: 0.5,
      '&:hover, &:focus, &:active, &.Mui-focusVisible': {
        backgroundColor: 'transparent',
        color: 'gray.56',
      },
      '&.Mui-disabled': {
        color: 'gray.16',
      },
    },
    '.MuiDayCalendar-weekDayLabel': {
      color: 'gray.64',
    },
    '.MuiPickersYear-yearButton': {
      color: 'gray.80',
      '&:hover, &:focus, &.Mui-focusVisible': {
        backgroundColor: 'gray.8',
      },
      '&.Mui-selected': {
        backgroundColor: 'primary.main',
        color: 'gray.0',
        '&:hover, &:focus': {
          backgroundColor: 'primary.dark',
        },
      },
    },
  },
  pickersDay: {
    fontSize: 14,
    color: 'gray.80',
    ':hover': {
      backgroundColor: 'gray.3',
    },
    '&.MuiPickersDay-today': {
      borderColor: 'gray.16',
      fontWeight: 600,
    },
    '&.Mui-selected': {
      fontWeight: 400,
    },
    width: 40,
    height: 40,
  },
  greyedOutDay: {
    color: 'gray.40',
  },
}

export const handleStylesWithProps = ({
  date,
  range,
  variant,
  selectedDay,
  isOutsideCurrentMonth,
  monthDate,
}) => {
  switch (variant) {
    case VARIANTS.WEEK: {
      const start = startOfWeek(selectedDay)
      const end = endOfWeek(selectedDay)

      const dayIsBetween = isValid(selectedDay) && isWithinInterval(date, { start, end })
      const isFirstDay = isSameDay(date, start)
      const isLastDay = isSameDay(date, end)

      return {
        pickersDay: {
          ...(isOutsideCurrentMonth && {
            color: 'gray.56',
          }),
          ...(dayIsBetween && {
            borderRadius: 0,
            backgroundColor: 'primary.main',
            color: 'gray.0',
            '&:hover, &:focus': {
              backgroundColor: 'primary.dark',
            },
          }),
          ...(isFirstDay && {
            borderTopLeftRadius: '50%',
            borderBottomLeftRadius: '50%',
          }),
          ...(isLastDay && {
            borderTopRightRadius: '50%',
            borderBottomRightRadius: '50%',
          }),
        },
      }
    }

    case VARIANTS.RANGE: {
      const isFirstDay = isSameDay(date, range[0])
      const isLastDay = isSameDay(date, range[1])
      const isFirstAndLastDaySelected = isValid(range[0]) && isValid(range[1])
      const dayIsBetween =
        isFirstAndLastDaySelected && isWithinInterval(date, { start: range[0], end: range[1] })

      return {
        pickersDay: {
          ...(isOutsideCurrentMonth && {
            color: 'gray.56',
          }),
          ...(dayIsBetween &&
            !isFirstDay &&
            !isLastDay && {
              backgroundColor: 'primary.lightest',
              borderRadius: '50% !important',
              color: 'primary.main',
            }),
          ...((isFirstDay || isLastDay) && {
            backgroundColor: 'primary.main',
            borderRadius: '50% !important',
            color: 'gray.0',
            '&.Mui-selected': {
              backgroundColor: 'primary.main',
              borderRadius: '50% !important',
            },
            ':hover': {
              backgroundColor: 'primary.dark',
            },
          }),
        },
      }
    }

    default: {
      const hasExtraWeekRow = getWeeksInMonth(monthDate) === 6

      return {
        pickersDay: {
          ...(isOutsideCurrentMonth && {
            color: 'gray.56',
          }),
        },
        root: {
          '.MuiPickersSlideTransition-root': {
            minHeight: hasExtraWeekRow ? 270 : 230,
          },
          height: hasExtraWeekRow ? 370 : 'initial',
        },
      }
    }
  }
}
